module.exports = __webpack_public_path__ + "img/w3_package_dark.0c3029dd.png";